// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mu-0";
export var assigneeDetails = "_mu-1";
export var assigneeInfo = "_mu-2";
export var dropdownContainer = "_mu-4";
export var dropdownImage = "_mu-5";
export var editAssigneeInfo = "_mu-3";
export var editAssigneeModalContainer = "_mu-6";
export var hidden = "_mu-8";
export var input = "_mu-7";